module.exports = __webpack_public_path__ + "img/googlesheets.2d265269.svg";